import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "react-oidc-context";

import axios from "../api/axios";
import { getMeaningfulErrorMessage } from "../utils/errorHandler";
import notification from "../utils/toasts";

const defaultContext = {
  idToken: null,
  hasTokenError: false,
};

const RootContext = createContext<{ idToken: string | null; hasTokenError: boolean }>(
  defaultContext
);

export const useRootContext = () => useContext(RootContext);

export const RootContextProvider = (props: { children: React.ReactElement }) => {
  const { children } = props;

  const [idToken, setIdToken] = useState<string>("");
  const [hasTokenError, setHasTokenError] = useState<boolean>(false);
  const auth = useAuth();

  useEffect(() => {
    const getPowerBiToken = async (token: string) => {
      try {
        const tokenResponse = await axios.get("/token", { headers: { Authorization: token } });
        setIdToken(tokenResponse.data);
        setHasTokenError(false);
      } catch (e) {
        console.error(e);
        setHasTokenError(true);
        notification.error(getMeaningfulErrorMessage(e, "Error fetching power BI credentials"));
      }
    };

    if (auth.isAuthenticated) {
      const token = `Bearer ${auth.user?.id_token}`;
      getPowerBiToken(token);
    }
  }, [auth]);

  const value = useMemo(() => ({ idToken, hasTokenError }), [idToken, hasTokenError]);

  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
};
